import React from 'react';

import { Box, Typography } from '@mui/material';

import { FacilityLayoutAttributes, SeatLayoutFacility } from '../charter.types';

import { SEAT_HEIGHT } from './seatConstants';

const placementToJustifySelf: Record<FacilityLayoutAttributes['placement'], 'start' | 'end' | 'center' | 'stretch'> = {
  left: 'start',
  center: 'center',
  right: 'end',
  full: 'stretch',
};

type FacilityTileProps = {
  facility: SeatLayoutFacility;
  attributes: FacilityLayoutAttributes;
};

export default function FacilityTile({ facility, attributes }: FacilityTileProps): React.JSX.Element {
  const { columnSpan, placement, label, color } = attributes;
  const justifySelf = placementToJustifySelf[placement];

  return (
    <Box
      sx={{
        gridColumn: `span ${columnSpan}`,
        bgcolor: color,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        color: 'text.primary',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: SEAT_HEIGHT,
        px: 1,
        textAlign: 'center',
        justifySelf,
        width: '100%',
      }}
      title={label}
      data-facility-type={facility.facilityType}
      data-facility-placement={placement}
    >
      <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
        {label}
      </Typography>
    </Box>
  );
}
